var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ProductInfoImage"},[_c('div',[_c('v-card',{staticClass:"mb-2",attrs:{"outlined":""}},[_c('v-img',{staticClass:"ProDetailsImg",attrs:{"height":"350","src":_vm.url}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }